import { ToolbarDebugView } from "./ToolbarDebugView";


const defaultOptions = {
	enable: false,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createDebugPlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };
	if (!options.enable) {
		return {};
	}

	return {
		getToolbarWidgets() {
			return [{
				key: 'debug-info',
				component: ToolbarDebugView,
			}]
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/debugPlugin/createDebugPlugin.js